webpackJsonp([88],{

/***/ "RgMP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-horizontal-text-video_c0a4c2053e3b024246379e2fd8f78cc9.html";

/***/ }),

/***/ "lsCU":
/***/ (function(module, exports, __webpack_require__) {

var SectionHorizontalTextVideo = (function () {
    function SectionHorizontalTextVideo() {
    }
    return SectionHorizontalTextVideo;
}());
angular.module('animatronApp.sectionHorizontalTextVideo', []).component('sectionHorizontalTextVideo', {
    bindings: {
        ltTitle: '<',
        description: '<',
        buttons: '<',
        video: '<',
    },
    controller: SectionHorizontalTextVideo,
    templateUrl: __webpack_require__("RgMP")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/88-257c10c0995a4d25fa59.min.js